import React, { lazy } from 'react'
import {
  Home as HomeIcon,
  HowToReg as HowToRegIcon,
  Groups as GroupsIcon,
  CalendarToday as CalendarTodayIcon,
  ManageAccounts as ManageAccountsIcon,
  People as PeopleIcon
} from '@mui/icons-material/'

import { roleConstant } from '../constants'

const Home = lazy(() => import('./Home'))
const Subscriber = lazy(() => import('./Subscriber'))
const Campaign = lazy(() => import('./Campaign'))
const Users = lazy(() => import('./Users'))
const Scheduler = lazy(() => import('./Scheduler'))
const MySubscribers = lazy(() => import('./MySubscribers'))
const RemoveSubscriber = lazy(() => import('./RemoveSubscriber'))
const Page404 = lazy(() => import('./Route404'))

const routes = [
  {
    name: 'home',
    icon: <HomeIcon />,
    component: Home,
    path: '/',
    roles: [roleConstant.ADMIN, roleConstant.OPERATOR],
    exact: true
  },
  {
    name: 'subscriber',
    icon: <HowToRegIcon />,
    component: Subscriber,
    path: '/subscribers',
    roles: [roleConstant.ADMIN, roleConstant.OPERATOR],
    exact: true
  },
  {
    name: 'campaign',
    icon: <GroupsIcon />,
    component: Campaign,
    path: '/campaign',
    roles: [roleConstant.ADMIN],
    exact: true
  },
  {
    name: 'users',
    icon: <ManageAccountsIcon />,
    component: Users,
    path: '/users',
    roles: [roleConstant.ADMIN],
    exact: true
  },
  {
    name: 'Scheduler',
    icon: <CalendarTodayIcon />,
    component: Scheduler,
    path: '/scheduler',
    roles: [roleConstant.ADMIN, roleConstant.OPERATOR],
    exact: true
  },
  {
    name: 'mySubscribers',
    icon: <PeopleIcon />,
    component: MySubscribers,
    path: '/my-subscribers',
    roles: [roleConstant.AGENCY],
    exact: true
  },
  {
    component: MySubscribers,
    path: '/',
    roles: [roleConstant.AGENCY],
    exact: true
  },
  {
    component: RemoveSubscriber,
    path: '/remove-subscriber/:code'
  },
  {
    component: Page404
  }
]

export default role => {
  const routesForRole = routes.filter(
    route => !route.roles || route.roles.includes(role)
  )

  return {
    sidebar: routesForRole.filter(route => !!route.name),
    browser: routesForRole
      .reduce(
        (routes, route) => [
          ...routes,
          ...(route.childrens ? route.childrens : [route])
        ],
        []
      )
      .filter(route => !!route.component)
  }
}
